import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setOpenModalBloqueioModulo } from "../../../store/actions/termos";
import ModalBloqueioPlano from "../../../components/ModalBloqueioPlano";
import { ModalLink } from "./styles";

const ModalBloqueioModulo = forwardRef((props, ref) => {
  const termos = useSelector((state) => state.termos);
  const dispatch = useDispatch();

  return (
    termos.openModalBloqueioModulo && (
      <ModalBloqueioPlano
        onClose={() => dispatch(setOpenModalBloqueioModulo(false))}
        title="O seu plano não contempla o acesso ao módulo selecionado."
        buttonText="Ok"
      >
        Mas você pode alterá-lo agora mesmo. Ligue para (32) 3212-4324 ou, se preferir, envie a sua mensagem{' '}
        <ModalLink href="http://www.e-auditoria.com.br/contato" target="_blank">
          através do site.
        </ModalLink>
      </ModalBloqueioPlano>
    )
);
});

export default ModalBloqueioModulo;